import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

function HelpButton({ rolePersian }) {
  return (
    <>
      {rolePersian != "بازاریاب" && (
        <div className="d-none d-lg-flex">
          <Link to="/help" className="btn btn-success">
            راهنمای گام به گام
          </Link>
        </div>
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    rolePersian: state.main.role,
  };
};
export default connect(mapStateToProps, null)(HelpButton);
